import React, { Component } from 'react';
import { Form, Input, Label, Button, Dropdown } from '../../../Form';

import withTranslations from '../../../../utils/translations/withTranslations';

class ClinicalResearch extends Component {
  constructor(...props) {
    super(...props);

    this.state = {
      isValid: true
    };
  }

  next() {
    this.props.saveItem(this.form.formData());
    this.props.next();
  }

  render() {
    const { translate, data = {}, previous } = this.props;
    const { isValid } = this.state;

    return (
      <div className="ClinicalResearch">
        <Form
          ref={form => (this.form = form)}
          onValidationChange={valid => this.setState({ isValid: valid })}
          className="ClinicalResearch__Form"
        >
          <h1>{translate('fiche.clinical_research.title')}</h1>

          <h2>{translate('fiche.clinical_research.visual_acuity')}</h2>

          <div className="Form__Horizontal">
            <div className="Form__Horizontal__Item">
              <Label text={translate('fiche.clinical_research.left_eye')} />
              <Input
                name="left_eye"
                rules={['required']}
                defaultValue={data.left_eye}
              />
            </div>
            <div className="Form__Horizontal__Item">
              <Label text={translate('fiche.clinical_research.right_eye')} />
              <Input
                name="right_eye"
                rules={['required']}
                defaultValue={data.right_eye}
              />
            </div>
          </div>

          <div className="Form__Horizontal">
            <div className="Form__Horizontal__Item">
              <Label
                text={translate('fiche.clinical_research.left_eye_correction')}
              />
              <Input
                name="left_eye_correction"
                defaultValue={data.left_eye_correction}
              />
            </div>
            <div className="Form__Horizontal__Item">
              <Label
                text={translate('fiche.clinical_research.right_eye_correction')}
              />
              <Input
                name="right_eye_correction"
                defaultValue={data.right_eye_correction}
              />
            </div>
          </div>

          <h2>{translate('fiche.clinical_research.field_of_vision')}</h2>

          <div className="Form__Horizontal">
            <div className="Form__Horizontal__Item">
              <Label text={translate('fiche.clinical_research.left_eye')} />
              <Dropdown
                name="field_of_vision_left_eye"
                rules={['required']}
                defaultValue={data.field_of_vision_left_eye}
                data={[
                  { value: '-', label: translate('fiche.normal') },
                  { value: 'limited', label: translate('fiche.limited') }
                ]}
              />
            </div>
            <div className="Form__Horizontal__Item">
              <Label text={translate('fiche.clinical_research.right_eye')} />
              <Dropdown
                name="field_of_vision_right_eye"
                rules={['required']}
                defaultValue={data.field_of_vision_right_eye}
                data={[
                  { value: '-', label: translate('fiche.normal') },
                  { value: 'limited', label: translate('fiche.limited') }
                ]}
              />
            </div>
          </div>

          <h2>{translate('fiche.clinical_research.color_view')}</h2>

          <div className="Form__Horizontal">
            <div className="Form__Horizontal__Item">
              <Label text={translate('fiche.clinical_research.left_eye')} />
              <Dropdown
                name="color_view_left_eye"
                rules={['required']}
                defaultValue={data.color_view_left_eye}
                data={[
                  { value: '-', label: translate('fiche.normal') },
                  { value: 'limited', label: translate('fiche.limited') }
                ]}
              />
            </div>
            <div className="Form__Horizontal__Item">
              <Label text={translate('fiche.clinical_research.right_eye')} />
              <Dropdown
                name="color_view_right_eye"
                rules={['required']}
                defaultValue={data.color_view_right_eye}
                data={[
                  { value: '-', label: translate('fiche.normal') },
                  { value: 'limited', label: translate('fiche.limited') }
                ]}
              />
            </div>
          </div>

          <h2>{translate('fiche.clinical_research.hearing_acuity')}</h2>

          <div className="Form__Horizontal">
            <div className="Form__Horizontal__Item">
              <Label text={translate('fiche.clinical_research.left_ear')} />
              <Dropdown
                name="hearing_acuity_left_ear"
                rules={['required']}
                defaultValue={data.hearing_acuity_left_ear}
                data={[
                  { value: '-', label: translate('fiche.normal') },
                  { value: 'limited', label: translate('fiche.limited') }
                ]}
              />
            </div>
            <div className="Form__Horizontal__Item">
              <Label text={translate('fiche.clinical_research.right_ear')} />
              <Dropdown
                name="hearing_acuity_right_ear"
                rules={['required']}
                defaultValue={data.hearing_acuity_right_ear}
                data={[
                  { value: '-', label: translate('fiche.normal') },
                  { value: 'limited', label: translate('fiche.limited') }
                ]}
              />
            </div>
          </div>

          <h2>{translate('fiche.clinical_research.otoscopy')}</h2>

          <div className="Form__Horizontal">
            <div className="Form__Horizontal__Item">
              <Label text={translate('fiche.clinical_research.left_ear')} />
              <Dropdown
                name="otoscopy_left_ear"
                rules={['required']}
                defaultValue={data.otoscopy_left_ear}
                data={[
                  { value: '-', label: translate('fiche.normal') },
                  { value: 'limited', label: translate('fiche.limited') }
                ]}
              />
            </div>
            <div className="Form__Horizontal__Item">
              <Label text={translate('fiche.clinical_research.right_ear')} />
              <Dropdown
                name="otoscopy_right_ear"
                rules={['required']}
                defaultValue={data.otoscopy_right_ear}
                data={[
                  { value: '-', label: translate('fiche.normal') },
                  { value: 'limited', label: translate('fiche.limited') }
                ]}
              />
            </div>
          </div>

          <h2>{translate('fiche.clinical_research.bmi')}</h2>

          <Label text={translate('fiche.clinical_research.length')} />
          <Input
            name="length"
            rules={['required']}
            placeholder="m"
            defaultValue={data.length}
          />

          <Label text={translate('fiche.clinical_research.weight')} />
          <Input
            name="weight"
            rules={['required']}
            placeholder="kg"
            defaultValue={data.weight}
          />

          <Label text={translate('fiche.clinical_research.fat_percentage')} />
          <Input
            name="fat_percentage"
            rules={['required']}
            placeholder="%"
            defaultValue={data.fat_percentage}
          />

          <Button
            solid
            className="Form__Button"
            disabled={!isValid}
            onClick={() => this.next()}
          >
            {translate('fiche.next')}
          </Button>
          <Button
            transparant
            className="Form__Button"
            onClick={() => previous()}
          >
            {translate('fiche.previous')}
          </Button>
        </Form>
      </div>
    );
  }
}

export default withTranslations(ClinicalResearch);
